export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];
  const row = [];
  for (let i = strNumber.length; i > 0; i -= 3) row.push(strNumber.substring(Math.max(i - 3, 0), i));

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    const chuc = Math.floor(so / 10);
    const donvi = so % 10;
    if (chuc > 1) {
      chuoi = ` ${chuSo[chuc]} mươi`;
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) chuoi = " linh";
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += ` ${chuSo[donvi]}`;
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    const tram = Math.floor(so / 100);
    const soDu = so % 100;
    if (daydu || tram > 0) return ` ${chuSo[tram]} trăm${docHangChuc(soDu, true)}`;
    return docHangChuc(soDu, false);
  };

  let ketQua = "";
  for (let i = row.length - 1; i >= 0; i -= 1) {
    const soNhom = parseInt(row[i], 10);
    if (soNhom > 0) ketQua += `${docKhoi(soNhom, i !== row.length - 1)} ${tien[i]}`;
  }

  const normalized = ketQua.trim();
  return `${normalized.charAt(0).toUpperCase() + normalized.slice(1)} đồng chẵn`;
};

export const getPrintTemplate = ({ data }) => `
<html>
  <head>
    <title>Biên Bản Thanh Lý (Nghiệm Thu) Hợp Đồng Giao Khoán</title>
    <style>
      @media print { @page { margin: 10mm; size: portrait; } }
      body { font-family: "Times New Roman", Times, serif; font-size: 16px; color: #000; padding: 24px; }
      .header { display:flex; justify-content:space-between; }
      .center { text-align:center; }
      .row { margin-top:8px; }
      .sign { display:flex; justify-content:space-between; margin-top:26px; text-align:center; }
      .sign-box { width:42%; }
      .sign-space { height:56px; }
      .sign-name { font-weight:bold; margin-top:4px; }
      .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
    </style>
  </head>
  <body>
    <div class="header">
      <div>
        <div><b>Đơn vị:</b> ${data.unit || ""}</div>
        <div><b>Bộ phận:</b> ${data.department || ""}</div>
      </div>
      <div class="center">
        <div><b>Mẫu số: 06 - LĐTL</b></div>
        <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC<br/>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
      </div>
    </div>

    <h2 class="center" style="margin:16px 0 6px">BIÊN BẢN THANH LÝ (NGHIỆM THU) HỢP ĐỒNG GIAO KHOÁN</h2>
    <div class="center">Ngày ${data.documentDate || ".../.../..."}</div>
    <div class="row" style="text-align:right">Số: ${data.documentNumber || ""}</div>

    <div class="row">Họ và tên: ${data.assignorName || ""}. Chức vụ ${data.assignorTitle || ""}. Đại diện ${data.assignorRepresentativeOf || ""}. Bên giao khoán</div>
    <div class="row">Họ và tên: ${data.assigneeName || ""}. Chức vụ ${data.assigneeTitle || ""}. Đại diện ${data.assigneeRepresentativeOf || ""}. Bên nhận khoán</div>

    <div class="row">Cùng thanh lý Hợp đồng số ${data.contractNumber || ""} ngày ${data.contractDate || ".../.../..."}</div>
    <div class="row">Nội dung công việc (ghi trong hợp đồng) đã được thực hiện: ${data.completedWorkContent || ""}</div>
    <div class="row">Giá trị hợp đồng đã thực hiện: ${data.executedContractValue || ""} đồng</div>
    <div class="row">${data.paidByParty || "..."} đã thanh toán cho ${data.paidToParty || "..."} số tiền là ${data.amountPaid || ""} đồng (viết bằng chữ)</div>
    <div class="row">Số tiền bị phạt do ${data.penaltyByParty || "..."} vi phạm hợp đồng: ${data.penaltyAmount || ""} đồng (viết bằng chữ)</div>
    <div class="row">Số tiền ${data.remainingByParty || "..."} còn phải thanh toán cho ${data.remainingToParty || "..."} là ${data.remainingAmount || ""} (viết bằng chữ)</div>
    <div class="row">Kết luận: ${data.conclusion || ""}</div>

    <div class="sign">
      <div class="sign-box">
        <b>Đại diện bên nhận khoán</b><br/><i>(Ký, họ tên)</i>
        <div class="sign-space"></div>
        <div class="sign-name">${data.assigneeSignName || data.assigneeName || ""}</div>
      </div>
      <div class="sign-box">
        <b>Đại diện bên giao khoán</b><br/><i>(Ký, họ tên)</i>
        <div class="sign-space"></div>
        <div class="sign-name">${data.assignorSignName || data.assignorName || ""}</div>
      </div>
    </div>

    <div class="page-number">1/1</div>
    <script>window.onload=function(){window.print();}</script>
  </body>
</html>`;
